import { Controller } from "stimulus"

// Switches which metric the summary penetration columns show (share of
// sales/margin/units/orders) without a page reload. Each cell carries the
// pre-computed share for every metric in data attributes.
export default class extends Controller {
  static targets = ["button", "header", "cell"]

  select(event) {
    this.show(event.currentTarget.dataset.metric)
  }

  show(metric) {
    const label = metric.charAt(0).toUpperCase() + metric.slice(1)

    this.buttonTargets.forEach(button => {
      const active = button.dataset.metric === metric
      button.classList.toggle("btn-secondary", active)
      button.classList.toggle("btn-outline-secondary", !active)
    })

    this.headerTargets.forEach(header => { header.textContent = `% of ${label}` })

    this.cellTargets.forEach(cell => {
      const share = parseFloat(cell.dataset[`share${label}`])
      const value = cell.querySelector(".pen-value")
      const bar = cell.querySelector(".pen-bar > div")

      if (isNaN(share)) {
        value.textContent = ""
        bar.style.width = "0%"
        delete cell.dataset.sortValue
      } else {
        value.textContent = `${share.toFixed(1)}%`
        bar.style.width = `${Math.min(Math.max(share, 0), 100).toFixed(1)}%`
        cell.dataset.sortValue = share
      }
    })
  }
}
